export const commonText = {
  "ELL Starter Fill in the Blank": {
    header: "Fill in the Blank",
    text: "In this section, each sentence will have one, two, or three blanks. You'll fill in each blank with one of the words from the list, or you'll leave the blank empty if no word is needed. Type the words you choose into the boxes. Remember to check your spelling! Let’s get started!"
  },
  "ELL Starter Fill in the Blanks": {
    header: "Fill in the Blank",
    text: "In this section, each sentence will have one, two, or three blanks. You'll fill in each blank with one of the words from the list, or you'll leave the blank empty if no word is needed. Type the words you choose into the boxes. Remember to check your spelling! Let’s get started!"
  },
  "ELL Intermediate Fill in the Blanks": {
    header: "Fill in the Blank",
    text: "In this section, each sentence will have one, two, three, or four blanks. You'll fill in each blank with one of the words from the list. For some questions, you can use one word from the list in two blanks. Type the words you choose into the boxes. Remember to check your spelling! Let’s get started!"
  },
  "ELL Intermediate Sentences": {
    header: "Writing Sentences",
    text: "Nice work! You only have two questions left. This next section is about future tense. Write the whole sentence for both of the questions. Let’s do this."
  },
  "ELL Advanced Sentences": {
    header: "Action Words in Sentences",
    text: "For each question in this section, write the whole sentence. Change the form of the underlined word to make it match the rest of the sentence. Remember to check your spelling! Let’s get started!"
  },
  "ELL Advanced Fill in the Blanks": {
    header: "Fill in the Blank",
    text: "Good work so far! In this section, each sentence will have one, two, three, or four blanks. When there are multiple blanks, only type each word once. Let’s get started!"
  },
  "ELL Halfway": {
    header: "You're halfway there!",
    text: "Keep up the great work!"
  },
  "ELL Starter Questions": {
    header: "Questions",
    text: "In this section, you'll be writing questions. Remember that questions have a question mark (?) at the end. You can do it!"
  },
  "ELL Starter Sentence Combining": {
    header: "Sentence Combining",
    text: "You’re almost finished! Just 3 questions left. In this section, you'll combine sentences into one sentence. You'll be given a joining word to use. Remember that a sentence only has one period. You've got this!"
  },
  "End: You Did it!": {
    header: "You did it!",
    text: "That’s it! You just finished the Quill Placement Activity. Results will be sent to your teacher, and we’ll get started on creating your learning plan."
  }
};
